import { PriceMainProps, ProductPriceViewProps } from 'common/components/product-price-view/types';
import { getPriceParts } from 'utils/price-parts';

export const setProps = ({
  price,
  currency,
  unit,
  prevPrice,
  locale,
  discountPercent,
}: PriceMainProps): ProductPriceViewProps => ({
  ...getPriceParts({ price, currencySlug: currency, locale }),
  unit,
  prevPrice: prevPrice ? prevPrice.toString() : '',
  discountPercent: discountPercent ?? discountPercent,
});

export const isValues = ({ price, currency }: PriceMainProps) => price && currency;
